/**
 * Created by Administrator on 2018/9/12.
 */


export default{
  config:{
    debug:true
  },
  print(key,value){
    if(this.config.debug){
      if(value){
        console.log(key,value);
      }else{
        console.log(key);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/service/ServiceLog.js